// extracted by mini-css-extract-plugin
export default {"card":"Modal_card__qxYTe"};